import React, { useContext, useMemo, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { UserContext } from "../../Utilis";

const userLocationMap = {
  "solin@ribarnice.hr": "solin",
  "podstrana@ribarnice.hr": "podstrana",
  "gomilica@ribarnice.hr": "gomilica",
  "omis@ribarnice.hr": "omis",
  "poljud@ribarnice.hr": "poljud",
  "mall@ribarnice.hr": "mall",
  "belvedere@ribarnice.hr": "belvedere",
  "kaufland@ribarnice.hr": "kaufland",
  "svkajo@ribarnice.hr": "svkajo",
  "brda@ribarnice.hr": "brda",
  "brela@ribarnice.hr": "brela",
  "cco@ribarnice.hr": "cco",
};

const Location = () => {
  const { user } = useContext(UserContext);
  const navigate = useNavigate();

  const redirectPath = useMemo(() => {
    if (user?.email && userLocationMap[user.email]) {
      return `/home/status/${userLocationMap[user.email]}`;
    }
    return null;
  }, [user]);

  useEffect(() => {
    if (redirectPath) {
      navigate(redirectPath);
    }
  }, [redirectPath, navigate]);

  return null;
};

export default Location;
